/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskWorkflowItemConfigurationTargetingOneOf1
 */
export interface TaskWorkflowItemConfigurationTargetingOneOf1 {
    /**
     * 
     */
    target_type?: TaskWorkflowItemConfigurationTargetingOneOf1TargetTypeEnum;
    /**
     * 
     */
    facility_ids?: Array<any>;
    /**
     * 
     */
    facility_system_tags?: Array<any>;
    /**
     * 
     */
    facility_custom_tag_ids?: Array<any>;
}


/**
 * @export
 */
export const TaskWorkflowItemConfigurationTargetingOneOf1TargetTypeEnum = {
    Facility: 'FACILITY',
} as const;
export type TaskWorkflowItemConfigurationTargetingOneOf1TargetTypeEnum = typeof TaskWorkflowItemConfigurationTargetingOneOf1TargetTypeEnum[keyof typeof TaskWorkflowItemConfigurationTargetingOneOf1TargetTypeEnum];


/**
 * Check if a given object implements the TaskWorkflowItemConfigurationTargetingOneOf1 interface.
 */
export function instanceOfTaskWorkflowItemConfigurationTargetingOneOf1(value: object): value is TaskWorkflowItemConfigurationTargetingOneOf1 {
    return true;
}

export function TaskWorkflowItemConfigurationTargetingOneOf1FromJSON(json: any): TaskWorkflowItemConfigurationTargetingOneOf1 {
    return TaskWorkflowItemConfigurationTargetingOneOf1FromJSONTyped(json, false);
}

export function TaskWorkflowItemConfigurationTargetingOneOf1FromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskWorkflowItemConfigurationTargetingOneOf1 {
    if (json == null) {
        return json;
    }
    return {
        
        'target_type': json['target_type'] == null ? undefined : json['target_type'],
        'facility_ids': json['facility_ids'] == null ? undefined : json['facility_ids'],
        'facility_system_tags': json['facility_system_tags'] == null ? undefined : json['facility_system_tags'],
        'facility_custom_tag_ids': json['facility_custom_tag_ids'] == null ? undefined : json['facility_custom_tag_ids'],
    };
}

export function TaskWorkflowItemConfigurationTargetingOneOf1ToJSON(json: any): TaskWorkflowItemConfigurationTargetingOneOf1 {
    return TaskWorkflowItemConfigurationTargetingOneOf1ToJSONTyped(json, false);
}

export function TaskWorkflowItemConfigurationTargetingOneOf1ToJSONTyped(value?: TaskWorkflowItemConfigurationTargetingOneOf1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target_type': value['target_type'],
        'facility_ids': value['facility_ids'],
        'facility_system_tags': value['facility_system_tags'],
        'facility_custom_tag_ids': value['facility_custom_tag_ids'],
    };
}

